<template lang='pug'>
  v-dialog(v-model='dialog' scrollable persistent max-width='90%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Nuevo Cliente
      v-card-text
        v-row(dense)
          v-flex(xs12='xs12')
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12' xs='12' sm='6' md='6')
                      v-text-field(v-if='dialog' @keyup.enter='changeText("nombreC")' autofocus v-model='form.nombre', id='nombreC' hint="Requerido", persistent-hint, outlined, :readonly='read' label='Nombre Comercial', dense, v-uppercase)
                    v-col(cols='12' xs='12' sm='6' md='6' class='d-flex justify-center')
                      div(class="d-flex justify-space-around")
                        div(class="pa-0 mr-2" style="width:70px")
                          v-select#rifLetra(@keyup.enter='changeText("rifLetra")' v-model='rifLetra' :items='items' outlined dense :readonly='read' )
                        div(class="pa-0")#rifC
                          v-text-field#rifCliente(@keyup.enter='changeText("rifCliente")' v-model='rifNumerico' hint="Requerido" persistent-hint :readonly='read' label='Rif' outlined dense v-mask="'#########'")
                  v-row(dense)
                    v-col(cols='12')
                      v-text-field#tlfC(@keyup.enter='changeText("tlfC")' v-model='form.telefono' v-mask="'####-#######'" :readonly='read' label='Telefono' outlined dense)
                    v-col(cols='12')#direccionC
                      v-textarea#direccionCliente(@keyup.enter='changeText("direccionCliente")' v-model='form.direccion', :readonly='read', label="Direción", outlined, dense, v-uppercase)
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar ( ESC )
        v-btn#buttonGuardar(v-if="!read" color='success' dark @click='save', @keyup.enter='save')
          v-icon mdi-content-save
          | Guardar ( ALT + G )
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read', 'mostrar'],
  name: 'ClienteM',
  data: () => ({
    rifLetra: 'V',
    numCodigoCli: '0424',
    digitos: '',
    rifNumerico: '',
    form: {
      nombre: '',
      rif: '',
      direccion: '',
      telefonos: '',
      telefono: ''
    },
    idArrays: [ 'nombreC', 'rifLetra', 'rifCliente', 'tlfC', 'direccionCliente', 'buttonGuardar' ],
    items: ['V', 'E', 'J', 'P', 'G', 'C'],
    itemsNum: ['0412', '0414', '0424', '0416', '0426', '0248', '0281', '0282', '0283', '0285', '0292', '0240', '0247', '0278', '0243', '0244', '0246',
      '0273', '0278', '0284', '0285', '0286', '0288', '0289', '0241', '0242', '0243', '0245', '0249', '0258', '0287', '0212', '0259', '0268',
      '0269', '0279', '0235', '0238', '0246', '0247', '0251', '0252', '0253', '0271', '0274', '0275', '0212', '0234', '0239', '0287', '0291',
      '0292', '0295', '0255', '0256', '0257', '0272', '0293', '0294', '0275', '0276', '0277', '0278', '0271', '0272', '0212', '0251', '0253',
      '0254', '0261', '0262', '0263', '0264', '0265', '0266', '0267', '0271', '0275' ],

    defaultItem: {
      nombre: '',
      rif: '',
      direccion: '',
      telefonos: '',
      telefono: ''
    }
  }),

  watch: {
    FormPadre (val) {
      if (val.idRuta) {
        this.selecRuta = val.idRuta._id
      }
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = Object.assign({}, this.defaultItem)
        this.formDefault(val, this.form)
        this.desconcatenarRif(val.rif)
        this.desconcatenarNum(val.telefono)
        if (this.form.lat && this.form.lng) {
          this.center.lat = this.form.lat
          this.center.lng = this.form.lng
        }
        this.e6 = 1
        if (
          this.form.codEstado !== '' &&
          this.form.codMunicipio !== '' &&
          this.form.codParroquia !== ''
        ) {
          this.changeEstado(val.codEstado._id)
          this.changeMunicipio(val.codMunicipio._id)
          this.changeParroquia(val.codParroquia._id)
        }
      }
    }
  },

  mounted () {
    window.addEventListener('keyup', (e) => {
      switch (e.key.toLowerCase()) {
        case 'escape':
          this.close()
          break
        case 'g':
          if (e.altKey) this.save()
          break
        default:
          return null
      }
    })
  },

  methods: {
    changeText: function (val) {
      const index = this.idArrays.findIndex(id => id === val)
      if (index === 5) {
        document.getElementById('nombreC').focus()
      } else {
        document.getElementById(this.idArrays[index + 1]).focus()
      }
    },

    concatenarRif () {
      this.form.rif = this.rifLetra + '-' + this.rifNumerico
    },
    desconcatenarRif (rif) {
      this.rifLetra = rif.charAt(0)
      this.rifNumerico = rif.substr(2)
    },
    concatenarNum () {
      this.form.telefono = this.numCodigoCli + '-' + this.digitos
    },
    desconcatenarNum (telf) {
      this.numCodigoCli = telf.substr(0, 4)
      this.digitos = telf.substr(5)
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.rifNumerico = ''
        this.rifLetra = 'V'
        this.form.rif = ''
        this.digitos = ''
        this.numCodigoCli = '0424'
        this.form.telefono = ''
      }, 300)
      this.$emit('close')
    },

    save () {
      this.concatenarRif()
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })
      Api.post('/cliente', this.form)
        .then(res => {
          if (res.data.status === 'denied') {
            this.$swal({
              icon: 'error',
              title: 'Error al guardar',
              text: res.data.message
            })
          } else {
            this.$emit('save', res.data)
            this.$swal({
              icon: 'success',
              title: 'Inclusion exitosa',
              text: 'Todos los datos han sido guardados'
            })
            this.close()
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    }
  }
}
</script>
